import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useAuthContext } from 'contexts/AuthContext';
import AddPoolModal from './AddPoolModal';
import './Dashboard.scss';

export default function FloatingPoolButton() {
  const { t } = useTranslation();
  const { userRole } = useAuthContext();
  const [showModal, setShowModal] = useState(false);

  // Repairer (3) cannot add pools; maintenance contractor (5) can add pools with YTM/admin/mine users
  const canAddPool = userRole !== 3;

  if (!canAddPool) {
    return null;
  }

  const handleSuccess = (newPool) => {
    // Refresh page or update state
    window.location.reload();
  };

  return (
    <>
      <button
        className="fab"
        onClick={() => setShowModal(true)}
        title={t('fab_add_pool')}
        aria-label={t('fab_add_pool')}
      >
        <i className="fas fa-plus fa-lg" />
      </button>
      
      <AddPoolModal
        isOpen={showModal}
        onClose={() => setShowModal(false)}
        onSuccess={handleSuccess}
      />
    </>
  );
} 